const metaPadrao = {
  subject: ["PROJETO"],
  action: ["read"],
  showMenu: true,
  grupo: "CRE",
  grupoTitle: "CRE",
};

export default [
  {
    path: "/sgi/dashboard",
    name: "GRAFICOS - SGI - GERAL",
    component: () => import("@/views/SGI/GraficosGeraisSgi.vue"),
    meta: {
      breadcrumb: "",
      title: "Dashboard Geral",
      icon: "mdi-view-dashboard",
      subject: ["TicketSgi"],
      action: ["read"],
      showMenu: true,
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },
  {
    path: "/sgi",
    name: "SGI - GERAL",
    component: () => import("@/views/SGI/DashboardSgi.vue"),
    meta: {
      breadcrumb: "",
      title: "SGI - GERAL",
      icon: "mdi-text-box-multiple-outline",
      subject: ["TicketSgi"],
      action: ["read"],
      showMenu: true,
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },
  {
    path: "/sgi/qualidade",
    name: "Qualidade",
    component: () => import("@/views/SGI/DashboardSgi.vue"),
    meta: {
      breadcrumb: "",
      title: "Qualidade",
      icon: "mdi-star-check",
      subject: ["TicketSgi"],
      action: ["read"],
      showMenu: true,
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },

  {
    path: "/sgi/meioAmbiente",
    name: "Meio Ambiente",
    component: () => import("@/views/SGI/DashboardSgi.vue"),
    meta: {
      breadcrumb: "",
      title: "Meio Ambiente",
      icon: "mdi-sprout",
      subject: ["TicketSgi"],
      action: ["read"],
      showMenu: true,
      grupo: "SGI",
      grupoTitle: "SGI",

    },
  },

  {
    path: "/sgi/seguranca",
    name: "Segurança",
    component: () => import("@/views/SGI/DashboardSgi.vue"),
    meta: {
      breadcrumb: "",
      title: "Segurança",
      icon: "mdi-security",
      subject: ["TicketSgi"],
      action: ["read"],
      showMenu: true,
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },

  {
    path: "/sgi/auditoria",
    name: "Auditoria",
    component: () => import("@/views/SGI/DashboardSgi.vue"),
    meta: {
      breadcrumb: "",
      title: "Auditoria",
      icon: "mdi-book-multiple",
      subject: ["TicketSgi"],
      action: ["read"],
      showMenu: true,
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },

  {
    path: "/sgi/acoes",
    name: " Listar Ações",
    component: () => import("@/views/SGI/ListarAcoes.vue"),
    meta: {
      breadcrumb: "",
      title: "Listar Ações",
      icon: "mdi-text-box-multiple-outline",
      showMenu: true,
      subject: ["TicketSgi"],
      action: ["readAcoes"],
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },
  {
    path: "/sgi/plano-acao",
    name: "Criar Plano de ação",
    component: () => import("@/views/SGI/CriarPlanoAcao.vue"),
    meta: {
      breadcrumb: "SGI - GERAL",
      title: "Criar Plano de ação",
      icon: "mdi-text-box-multiple-outline",
      showMenu: false,
      grupo: "SGI",
      grupoTitle: "SGI",
    },
  },
];
